import React, { useEffect, useMemo, useRef, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { fetchPlaylists as actionFP } from '../../../actions/content/playlists'
import { attachMediaToPlaylist as actionAMP, detachMediaToPlaylist as actionDMP } from '../../../actions/content/media'
import { Confirmation, Input, Padding, List } from '../../../components'

const MediaPlaylistModal = ({
    attachMediaToPlaylist,
    children,
    detachMediaToPlaylist,
    fetchPlaylists,
    inSelectedPlaylist,
    mediaID,
    mediaPlaylists,
    playlists,
    t,
    order,
}) => {
    const inputRef = useRef(null)
    const [isOpen, setIsOpen] = useState(false)
    const [playlistSearch, setPlaylistSearch] = useState('')

    // Playlists
    const playlistOptions = useMemo(
        () =>
            playlists.map(({ id, name }) => ({
                key: id,
                value: name,
            })),
        [playlists]
    )

    // -----------------------------
    // EFECTS
    // -----------------------------
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus()
        }
    }, [])

    useEffect(() => {
        if (isOpen) {
            fetchPlaylists(0, { name: playlistSearch })
        }
    }, [playlistSearch, isOpen, fetchPlaylists])

    const renderBody = () => (
        <Padding size="sm">
            <Padding top size="sm">
                {playlists && !!playlists.length && (
                    <List
                        data={mediaPlaylists}
                        display="name"
                        onRemove={(index) => detachMediaToPlaylist(mediaID, mediaPlaylists[index].id, inSelectedPlaylist, order)}
                    />
                )}
                <Input
                    ref={inputRef}
                    type="suggestions"
                    onChange={(playlistID) => attachMediaToPlaylist(mediaID, playlistID, inSelectedPlaylist)}
                    onTextChange={setPlaylistSearch}
                    options={playlistOptions}
                />
            </Padding>
        </Padding>
    )

    return (
        <Confirmation
            header={t('playlists')}
            confirmation={renderBody()}
            onCancel={() => setIsOpen(false)}
            onConfirm={() => setIsOpen(false)}
            onOpen={() => setIsOpen(true)}
        >
            {children}
        </Confirmation>
    )
}

MediaPlaylistModal.propTypes = {
    attachMediaToPlaylist: PropTypes.func.isRequired,
    children: PropTypes.node,
    detachMediaToPlaylist: PropTypes.func.isRequired,
    fetchPlaylists: PropTypes.func.isRequired,
    inSelectedPlaylist: PropTypes.bool,
    mediaID: PropTypes.number.isRequired,
    mediaPlaylists: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    playlists: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    t: PropTypes.func.isRequired,
}

MediaPlaylistModal.defaultProps = {
    children: null,
    inSelectedPlaylist: false,
}

const mapStateToProps = ({ content: { playlists } }) => ({ playlists })

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            attachMediaToPlaylist: actionAMP,
            detachMediaToPlaylist: actionDMP,
            fetchPlaylists: actionFP,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MediaPlaylistModal))
